import React, { useEffect, useState } from "react";
import API from "helpers/api";
import { PRODUCT_UPDATE_NOTIFICATION_REFRESH_EVENT } from "helpers/constants";
import WhatsNewDialog from "./WhatsNewDialog";

// Only the few newest featured updates open the modal; the rest live in the
// Release notes list. Keeps a backlog from feeling like a slog (design §10.4).
const MAX_MODAL_STACK = 3;

function broadcastRefresh() {
	window.dispatchEvent(
		new CustomEvent(PRODUCT_UPDATE_NOTIFICATION_REFRESH_EVENT),
	);
}

function WhatsNewModal() {
	const [updates, setUpdates] = useState([]);
	const [index, setIndex] = useState(0);
	const [open, setOpen] = useState(false);

	useEffect(() => {
		let cancelled = false;

		API.get("/api/product-updates/unread")
			.then((res) => {
				if (cancelled) return;
				const featured = (res?.data || [])
					.filter((u) => u.importance === "featured")
					.slice(0, MAX_MODAL_STACK);

				if (featured.length === 0) return;
				setUpdates(featured);
				setOpen(true);
			})
			.catch(() => {
				// 401 / network - no modal
			});

		return () => {
			cancelled = true;
		};
	}, []);

	const current = updates[index];
	const isLast = index >= updates.length - 1;

	const markCurrentRead = () => {
		if (!current) return Promise.resolve();
		return API.post(`/api/product-updates/${current.id}/mark-read`)
			.then(broadcastRefresh)
			.catch(() => {});
	};

	const advance = () => {
		if (isLast) {
			setOpen(false);
		} else {
			setIndex((i) => i + 1);
		}
	};

	const handleNext = () => {
		markCurrentRead();
		advance();
	};

	// Closing without an explicit choice does NOT mark read - it reappears next login.
	const handleDismiss = () => setOpen(false);

	const handleSkipAll = () => {
		API.post("/api/product-updates/mark-all-read")
			.then(broadcastRefresh)
			.catch(() => {});
		setOpen(false);
	};

	const handleReadArticle = () => {
		markCurrentRead();
		if (current?.externalUrl) {
			window.open(current.externalUrl, "_blank", "noopener,noreferrer");
		}
		advance();
	};

	return (
		<WhatsNewDialog
			open={open}
			updates={updates}
			index={index}
			onNext={handleNext}
			onSkipAll={handleSkipAll}
			onDismiss={handleDismiss}
			onReadArticle={handleReadArticle}
		/>
	);
}

export default WhatsNewModal;
